import MessageInput from './MessageInput.js'
import Events from './Events.js'
import Typing from './Typing.js'
import QuickReplies from './QuickReplies.js'
const browser = require('bowser').getParser(window.navigator.userAgent).parsedResult
import Header from './Header.js'
import PoweredBy from './PoweredBy.js'
import Rating from './Rating.js'
import ListField from './ListField.js'
import store from '@sb/store'
var sb = require('@sb/util')

export default {
	name: 'Convo',
	props: ['convoKey', 'isShow', 'forceMode'],

	data () {
		return {
			...store.bind(this, ['user', 'accountSetting', 'convoM', 'convoEventM', 'convoIdM']),

			// TODO: lastview
			// value:  'chat', 'viewonly', ('prechat' = 'offline' = 'form)
			// dont modify this variable, should call display()
			mode: '',
			cvkey: '', // conversation key that we can modify
			form: {},
			formData: {},
			selectedGroupId: '', // last picked group id
			emptyEvents: [],
		}
	},

	watch: {
		isShow (isShow) {
			if (isShow && !browser.platform.type === 'mobile') this.focusInput()
			if (isShow && browser.platform.type === 'mobile') this.blur()
		},
		convoKey (k) {
			this.cvkey = this.convoKey
			this.display({ mode: this.forceMode, cvkey: this.cvkey })
		},
		convoIdM (v) {
			store.setLastview('chat', { convoKey: this.cvkey, convoId: this.convoIdM[this.cvkey] || '', forceMode: this.mode })
		},
		accountSetting (accountSetting) {
			this.init()
		},
	},

	created () {
		this.init()
		store.onConvoEvent(this, ev => {
			if (!this.isShow) return
			if (sb.convoKeyOfEv(ev) !== this.cvkey) return
			// if message if not from me => seen
			store.seenConvo(this.cvkey)

			let isEndedConvo = sb.get(store.lookupConvo(this.cvkey), 'state') === 'ended'
			if (isEndedConvo) return this.display({ mode: 'viewonly' })
		})
	},

	render () {
		var $body = null
		if (this.mode === 'form' || this.mode === 'offline' || this.mode === 'prechat') $body = this.renderForm()
		else if (this.mode === 'viewonly') $body = this.renderViewOnly()
		else $body = this.renderChat()

		let cls = 'widget-container '
		let position = sb.get(this.accountSetting, 'desktop_button.position') || 'right'
		if (browser.platform.type === 'mobile') position = sb.get(this.accountSetting, 'mobile_button.position') || position
		cls += ' widget-container--' + position
		cls += this.isShow ? '' : ' widget-container--hide'
		return (
			<div class={cls}>
				{this.renderHeader()}
				{$body}
			</div>
		)
	},

	methods: {
		init () {
			if (this.isShow) store.seenConvo(this.convoKey)
			this.cvkey = this.convoKey

			var mode = this.forceMode
			// choose form to display
			if (sb.get(store, 'accountSetting.prechat_form.enabled')) this.form = this.accountSetting.prechat_form
			if (this.forceMode === 'offline') {
				this.form = this.accountSetting.offline_form
			} else {
				//auto detect form
				let offlineEnabled = sb.get(store, 'accountSetting.offline_form.enabled')
				if (!sb.get(store.accountSetting, 'is_online') && offlineEnabled) {
					this.form = this.accountSetting.offline_form
				}
			}

			// guard against invalid mode
			if (this.forceMode === 'offline' || this.forceMode === 'prechat') mode = 'form'
			if (mode !== '' && mode !== 'form' && mode !== 'viewonly') mode = ''
			this.display({ mode, cvkey: this.cvkey })
		},

		blur () {
			if (store.isPreview) return
			var $input = this.$refs.msgInput
			if (!$input) return
			this.$nextTick(() => $input.blur())
			setTimeout(() => $input.blur(), 300) // force lose focus
		},

		focusInput () {
			if (store.isPreview) return
			var $input = this.$refs.msgInput
			if (!$input) return
			this.$nextTick(() => $input.focus())
			setTimeout(() => $input.focus(), 300) // force focus
		},

		onRate (rating) {
			let convoKey = this.cvkey
			if (!convoKey) return
			store.sendConvoEventData(convoKey, 'conversation_rated', { conversation: { ratings: [rating] } })
			this.focusInput()
			store.sendEventToThirdParty('SUBIZ Chat', 'Sent', 'User')
		},

		sendMessage (message) {
			let convoKey = this.cvkey
			let text = message.text
			if (!convoKey) {
				const convo = store.startConvo({ group_id: this.selectedGroupId, message: text })
				convoKey = convo._key
				store.sendConvoEvent(convoKey, message)
				return this.display({ mode: 'chat', cvkey: convo._key })
			}
			store.sendConvoEvent(convoKey, message)
			store.sendEventToThirdParty('SUBIZ Chat', 'Sent', 'User')
		},

		renderViewOnly () {
			return (
				<div class="widget-body">
					<div class="widget-body--content" vOn:click={this.onContainerClick}>
						<Events vOn:formSubmit={this.onEventFormSubmit} ref="events" convoKey={this.cvkey} />
						<Typing convoKey={this.cvkey} />
						<QuickReplies convoKey={this.cvkey} vOn:select={this.chooseQuickReply} />
					</div>
					<Rating convoKey={this.cvkey} vOn:rate={this.onRate} />
					<div class="message-input message-input--preform">
						<button class="btn--start-convo" vOn:click={this.onStartConvoClick}>
							{this.$t('offline_preform_btn')}
						</button>
					</div>
				</div>
			)
		},

		renderChat () {
			return (
				<div class="widget-body">
					<div class="widget-body--content" vOn:click={this.onContainerClick}>
						<Events vOn:formSubmit={this.onEventFormSubmit} ref="events" convoKey={this.cvkey} />
						<Typing convoKey={this.cvkey} />
						<QuickReplies convoKey={this.cvkey} vOn:select={this.chooseQuickReply} />
					</div>
					<Rating vOn:rate={this.onRate} convoKey={this.cvkey} />
					<MessageInput ref="msgInput" convoKey={this.cvkey} vOn:send={this.sendMessage} />
				</div>
			)
		},

		renderHeader () {
			let headerMode = 'collapsed'
			if (sb.size(this.convoEventM[this.cvkey]) === 0) headerMode = 'expanded'
			if (this.mode === 'form' || this.mode === 'offline' || this.mode === 'prechat') headerMode = 'collapsed'
			// if (this.mode === 'form') headerMode = 'collapsed'
			return (
				<div class={`widget-header widget-header--convo-${headerMode}`}>
					<Header
						convoKey={this.convoKey}
						agentsJoined={getAgentJoined(this.cvkey)}
						vOn:close={() => this.$emit('close')}
						vOn:gotoList={() => this.$emit('go', { view: 'list' })}
						mode={headerMode}
					/>
				</div>
			)
		},

		display (data) {
			if (data.mode !== undefined) this.mode = data.mode
			if (data.cvkey !== undefined) this.cvkey = data.cvkey

			if (data.mode === 'form') {
				this.formData = this.fillForm(this.form)
			}

			if (!data.mode) {
				if (this.cvkey) {
					var convo = store.lookupConvo(this.cvkey) || {}
					let sent = userHasSent(this.cvkey)
					if (!sent) {
						if (this.isFormRequired()) return this.display({ mode: 'viewonly', cvkey: this.cvkey })
						return this.display({ mode: 'chat', cvkey: this.cvkey })
					}
					if (convo.state === 'ended') return this.display({ mode: 'viewonly', cvkey: this.cvkey })
					return this.display({ mode: 'chat', cvkey: this.cvkey })
				}

				if (this.isFormRequired()) return this.display({ mode: 'form' })
				return this.display({ mode: 'chat' })
			}

			store.setLastview('chat', { convoKey: this.cvkey, convoId: store.convoIdM[this.cvkey] || '', forceMode: this.mode })
			this.$nextTick(() => {
				// focus Events then focus MessageInput
				// if there is any pending form, MessageInput will be disabled
				// and dont steal focus from Events
				this.$refs.events && this.$refs.events.focus()
				this.focusInput()
			})
		},

		async onStartConvoClick () {
			await store.fetchUserSetting()
			// this.cvkey must have value. See render function
			var convo = store.lookupConvo(this.cvkey) || {}
			if (convo.state === 'ended') {
				// need form?
				this.cvkey = ''
				if (this.isFormRequired()) return this.display({ mode: 'form' })
				return this.display({ mode: 'chat', cvkey: '' })
			}

			// user have not sent and conversation requires form
			return this.display({ mode: 'form' })
		},

		onEventFormSubmit () {
			this.focusInput()
		},

		chooseQuickReply (value) {
			this.$refs.msgInput.submitMessage(value)
		},

		onContainerClick () {
			// ignore select behaviour
			var selection = window.getSelection()
			if (selection.toString().length > 0) return

			// focus text input on desktop
			if (!browser.platform.type === 'mobile') this.focusInput()
		},

		renderForm () {
			let btnText = this.$t('prechat_form_btn')
			if (this.mode === 'offline') {
				btnText = this.$t('offline_form_btn')
			}

			let $title = null
			if (this.form.title) $title = <p>{this.form.title}</p>
			return (
				<div class="widget-body">
					<div class="widget-body--content flex-grow-1 pl-3 pr-3 d-flex flex-column">
						<div class="flex-grow-1">
							<div class="form mt-3 pl-3 pr-3 pt-3 pb-3 d-flex flex-column">
								{$title}
								{this.renderFields()}
								<button class="btn--start-convo mt-3" vOn:click={this.submitInfoForm}>
									{btnText}
								</button>
							</div>
						</div>
						<PoweredBy />
					</div>
					<MessageInput disabled={true} />
				</div>
			)
		},

		fillForm (form) {
			if (sb.size(form) === 0) return []
			this.selectedGroupId = ''
			// init data
			var data = {}
			sb.each(form.fields, f => {
				var newf = Object.assign({}, f)
				// fill in user attribute
				newf.value = sb.getUserAttr(this.user, f.key, f.type)

				if (f.type === 'boolean' && !newf.value) newf.value = false
				if (f.type === 'datetime' && newf.value) {
					// time picker only show if we pass time in this format yyyy-MM-dd
					newf.value = new Date(data.value).toLocaleDateString('en-CA')
				}

				if (f.type === 'list') {
					newf.list = f.list
				}
				data['attr:' + f.key] = newf
			})

			if (!this.cvkey) {
				if (form.group_required !== undefined && form.groups && form.groups.length > 0) {
					data['group'] = {
						key: 'group',
						is_required: !!form.group_required,
						label: form.group_label,
						type: 'group',
						list: sb.map(form.groups, group => ({ value: group.id, label: group.name })),
					}
				}

				if (form.question_required !== undefined) {
					data['question'] = {
						key: 'question',
						is_required: !!form.question_required,
						label: form.question_label,
						type: 'text',
					}
				}
			}
			return data
		},

		firstUnfilledField () {
			return sb.find(this.formData, field => field.value == null || field.value === '')
		},

		isFormRequired () {
			let formData = this.fillForm(this.form)
			if (this.cvkey) {
				delete formData.group
				delete formData.question
			}

			return !!sb.find(formData, field => field.value == null || field.value === '')
		},

		// submit prechat or offline form
		submitInfoForm () {
			var hasError = false
			sb.map(this.formData, (field, key) => {
				if (
					field.is_required &&
					(field.value === undefined ||
						field.value === '' ||
						(sb.size(field.value) === 0 && Array.isArray(field.value)))
				) {
					field.error = this.$t('error_empty')
					hasError = true
				} else field.error = ''

				if (key.substr(5) === 'emails' && !sb.isEmail(field.value)) {
					field.error = this.$t('error_email_invalid') // 'The email is not valid'
					hasError = true
				}
			})

			// rerender
			this.$forceUpdate()
			if (hasError) return

			let user = sb.cloneDeep(this.user)
			sb.map(this.formData, (field, key) => {
				if (!key.startsWith('attr:')) return
				var attr = { key: key.substr(5) }
				if (field.type === 'number') attr.number = parseInt(field.value)
				if (field.type === 'datetime') attr.datetime = new Date(field.value).toISOString()
				if (field.type === 'list') attr.list = field.value
				if (field.type === 'text' || field.type === 'boolean') attr[field.type] = field.value
				sb.setUserAttr(user, attr)
			})
			store.setUser(user)

			var groupid = sb.get(this.formData, 'group.value', '')
			if (groupid) this.selectedGroupId = groupid

			let message = { text: sb.get(this.formData, 'question.value'), format: 'plaintext' }
			let req = { group_id: groupid, message: message.text }

			if (!this.cvkey) {
				// we can delay creating conversation if user don't type message
				if (req.message) {
					const convo = store.startConvo(req)
					store.sendConvoEvent(convo._key, message)
					return this.display({ mode: 'chat', cvkey: convo._key, events: ['thanks'] })
				}
				return this.display({ mode: 'chat', cvkey: '', events: ['thanks'] })
			}

			if (message.text) store.sendConvoEvent(this.cvkey, message)
			return this.display({ mode: 'chat', cvkey: this.cvkey, events: ['thanks'] })
		},

		renderFields () {
			if (sb.size(this.formData) === 0) return null

			let firstChild = true
			let $fields = sb.map(this.formData, (field, key) => {
				let $field = null
				var errclass = field.error ? 'input--error' : ''
				if (field.type === 'text') {
					if (key === 'question') {
						$field = (
							<textarea
								class="form-control"
								ref={'field.' + key}
								vModel={field.value}
								row="4"
								class="form-control"></textarea>
						)
					} else {
						$field = <input ref={'field.' + key} vModel={field.value} class={`form-control ${errclass}`} type="text" />
					}
				} else if (field.type === 'number') {
					$field = <input vModel={field.value} class={`form-control ${errclass}`} type="number" />
				} else if (field.type === 'boolean') {
					$field = (
						<div class="checkbox">
							<input
								ref={'field.' + key}
								type="checkbox"
								id={'form-checkbox' + key}
								onChange={ev => (field.value = ev.target.checked)}
								checked={field.value}
							/>
							<label class="checkbox--label" for={'form-checkbox' + key}>
								{field.label}
							</label>
							<div class="checkbox--check">
								<div></div>
							</div>
						</div>
					)
				} else if (field.type === 'group') {
					$field = sb.map(field.list, item => (
						<div class="radio">
							<input type="radio" id={'form-radio' + key + item.value} vModel={field.value} value={item.value} />
							<label class="radio--label" for={'form-radio' + key + item.value} value={item.value}>
								{item.label}
							</label>
							<div class="radio--check">
								<div class="inside"></div>
							</div>
						</div>
					))
				} else if (field.type === 'list') {
					if (!Array.isArray(field.value)) {
						this.formData[key].value = this.formData[key].value || []
					}
					let selected = this.formData[key].value
					let items = sb.filter(sb.get(field, 'list', []), item => {
						return !this.formData[key].value.includes(item)
					})
					$field = (
						<ListField
							selected={selected}
							items={items}
							vOn:onAddItem={item => this.formData[key].value.push(item)}
							vOn:onRemoveItem={i => this.$delete(this.formData[key].value, i)}
						/>
					)
				} else if (field.type === 'datetime') {
					$field = <input ref={'field.' + key} vModel={field.value} class={`form-control ${errclass}`} type="date" />
				}

				let label = field.label
				if (field.key === 'fullname') {
					label = this.$t('fullname')
				} else if (field.key === 'emails') {
					label = this.$t('email')
				} else if (field.key === 'phones') {
					label = this.$t('phones')
				}

				let cls = 'mt-3'
				if (firstChild) cls = '' // dont add margin for the first field
				firstChild = false
				return (
					<div class={cls}>
						<p class="label label__no_top">
							{label}
							{field.is_required ? <span class="ml-1 red">*</span> : ''}
						</p>
						{field.error ? <div class="form-control--valid-input--error">{field.error}</div> : ''}
						{$field}
					</div>
				)
			})
			return <div>{$fields}</div>
		},
	},
}

function userHasSent (cvkey) {
	var convo = store.lookupConvo(cvkey) || {}
	let joined = sb.find(convo.members, mem => mem.id === store.user.id && mem.membership === 'active')

	if (joined) return true
	var events = store.convoEventM[cvkey] || {}
	let sent = sb.find(events, ev => sb.get(ev, 'by.id') === store.user.id && ev.type === 'messeage_sent')
	return sent
}

function getAgentJoined (cvkey) {
	var convo = store.lookupConvo(cvkey) || {}
	let joined = sb.filter(convo.members, mem => mem.type === 'agent' && mem.membership === 'active')
	return joined
}
